import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Import all tour package images
import koreaImg from '../../assets/img/korea.png';
import bangkokImg from '../../assets/img/BANGKOK.png';
import jejuImg from '../../assets/img/JEJU.png';
import keralaImg from '../../assets/img/kerala.jpg';
import busanImg from '../../assets/img/BUSAN.png';
import maduraiImg from '../../assets/img/MADHURAI.png';
import seoulImg from '../../assets/img/SEOUL.png';
import karnatakaImg from '../../assets/img/kRNtK.png';

const TourPackages = () => {
    const [activeSlideGroup, setActiveSlideGroup] = useState(0);
    const [visibleSlides, setVisibleSlides] = useState(3);
    const sliderRef = useRef(null);

    const tourPackages = [
        {
            id: 1,
            image: koreaImg,
            title: "South India & Korea Cultural Fusion",
            location: "Kerala, Seoul, Busan",
            duration: "10 Days - 4 Nights",
            discount: "40% off",
            price: "95000",
            originalPrice: "135000",
            packageId: "south-india-korea"
        },
        {
            id: 2,
            image: bangkokImg,
            title: "Luxury Thailand & Vietnam Experience",
            location: "Bangkok, Phuket, Hanoi",
            duration: "8 Days - 3 Nights",
            discount: "45% off",
            price: "82000",
            originalPrice: "125000",
            packageId: "thailand-vietnam"
        },
        {
            id: 3,
            image: jejuImg,
            title: "Best of South Korea - Seoul to Jeju",
            location: "Seoul, Busan, Jeju Island",
            duration: "8 Days - 3 Nights",
            discount: "35% off",
            price: "78000",
            originalPrice: "105000",
            packageId: "jeju-island"
        },
        {
            id: 4,
            image: keralaImg,
            title: "Kerala Backwaters & Beach Paradise",
            location: "Alleppey, Munnar, Kovalam",
            duration: "7 Days - 2 Nights",
            discount: "35% off",
            price: "45000",
            originalPrice: "62000",
            packageId: "kerala-retreat"
        },
        {
            id: 5,
            image: busanImg,
            title: "Korea & Japan Cultural Journey",
            location: "Seoul, Tokyo, Osaka",
            duration: "12 Days - 4 Nights",
            discount: "50% off",
            price: "145000",
            originalPrice: "210000",
            packageId: "busan-coastal"
        },
        {
            id: 6,
            image: maduraiImg,
            title: "Tamil Nadu Temple Trail & Culture",
            location: "Chennai, Mahabalipuram, Madurai",
            duration: "6 Days - 2 Nights",
            discount: "40% off",
            price: "38000",
            originalPrice: "52000",
            packageId: "tamil-nadu-temple"
        },
        {
            id: 7,
            image: seoulImg,
            title: "Korea Winter Wonderland",
            location: "Seoul, Pyeongchang, Gangwon",
            duration: "6 Days - 2 Nights",
            discount: "25% off",
            price: "72000",
            originalPrice: "90000",
            packageId: "seoul-discovery"
        },
        {
            id: 8,
            image: karnatakaImg,
            title: "Karnataka Heritage & Hill Stations",
            location: "Bangalore, Mysore, Coorg",
            duration: "5 Days - 2 Nights",
            discount: "30% off",
            price: "32000",
            originalPrice: "42000",
            packageId: "karnataka-heritage"
        }
    ];

    // Calculate total slide groups
    const totalSlideGroups = Math.ceil(tourPackages.length / visibleSlides);

    // Handle responsive slides
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setVisibleSlides(1);
            } else if (window.innerWidth < 992) {
                setVisibleSlides(2);
            } else {
                setVisibleSlides(3);
            }
            // Reset to first slide group when resizing
            setActiveSlideGroup(0);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleNext = () => {
        setActiveSlideGroup(prev => {
            const nextGroup = prev + 1;
            return nextGroup >= totalSlideGroups ? 0 : nextGroup;
        });
    };

    const handlePrev = () => {
        setActiveSlideGroup(prev => {
            const prevGroup = prev - 1;
            return prevGroup < 0 ? totalSlideGroups - 1 : prevGroup;
        });
    };

    // Calculate slide width based on visible slides
    const getSlideWidth = () => {
        return `${100 / visibleSlides}%`;
    };

    // Calculate transform value for sliding
    const getTransformValue = () => {
        return `translateX(-${activeSlideGroup * 100}%)`;
    };

    // Group packages into slides
    const groupedPackages = [];
    for (let i = 0; i < tourPackages.length; i += visibleSlides) {
        groupedPackages.push(tourPackages.slice(i, i + visibleSlides));
    }

    return (
        <section className="vs-tour-package space" style={{ padding: '80px 0', background: '#f8f9fa' }}>
            <div className="container">
                <div className="row justify-content-between align-items-center">
                    <div className="col-md-6 col-lg-6 col-xxl-5">
                        <div className="title-area text-center text-md-start">
                            <span
                                className="sec-subtitle"
                                style={{
                                    display: 'block',
                                    color: '#f7921f',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    letterSpacing: '2px',
                                    marginBottom: '10px'
                                }}
                            >
                                Awesome Tours
                            </span>
                            <h2
                                className="sec-title"
                                style={{
                                    fontSize: '36px',
                                    fontWeight: '700',
                                    color: '#2c3e50',
                                    lineHeight: '1.3',
                                    margin: 0
                                }}
                            >
                                Awesome Trips with us
                            </h2>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xxl-5">
                        <div
                            className="tour-packages-navigation justify-content-center justify-content-md-end"
                            style={{
                                display: 'flex',
                                gap: '10px',
                                justifyContent: 'flex-end'
                            }}
                        >
                            <button
                                className="tour-packages-prev"
                                onClick={handlePrev}
                                style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    border: '2px solid #f7921f',
                                    background: 'transparent',
                                    color: '#f7921f',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.background = '#f7921f';
                                    e.target.style.color = 'white';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.background = 'transparent';
                                    e.target.style.color = '#f7921f';
                                }}
                            >
                                <svg width="9" height="18" viewBox="0 0 9 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.08984 16.92L1.56984 10.4C0.799843 9.62996 0.799843 8.36996 1.56984 7.59996L8.08984 1.07996" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <button
                                className="tour-packages-next"
                                onClick={handleNext}
                                style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    border: '2px solid #f7921f',
                                    background: 'transparent',
                                    color: '#f7921f',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.background = '#f7921f';
                                    e.target.style.color = 'white';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.background = 'transparent';
                                    e.target.style.color = '#f7921f';
                                }}
                            >
                                <svg width="9" height="18" viewBox="0 0 9 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.910156 16.92L7.43016 10.4C8.20016 9.62996 8.20016 8.36996 7.43016 7.59996L0.910156 1.07996" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div
                        className="col-12 mt-30 mt-md-0"
                        style={{ marginTop: '30px' }}
                    >
                        <div
                            ref={sliderRef}
                            className="tour-package-slider-container"
                            style={{
                                overflow: 'hidden',
                                position: 'relative',
                                width: '100%'
                            }}
                        >
                            <div
                                className="tour-package-slider"
                                style={{
                                    display: 'flex',
                                    transition: 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                                    transform: getTransformValue(),
                                    width: `${totalSlideGroups * 100}%`
                                }}
                            >
                                {groupedPackages.map((slideGroup, groupIndex) => (
                                    <div
                                        key={groupIndex}
                                        className="tour-package-slide-group"
                                        style={{
                                            width: `${100 / totalSlideGroups}%`,
                                            flexShrink: 0,
                                            display: 'flex',
                                            padding: '0 15px',
                                            boxSizing: 'border-box'
                                        }}
                                    >
                                        {slideGroup.map((pkg) => (
                                            <div
                                                key={pkg.id}
                                                className="tour-package-slide"
                                                style={{
                                                    width: getSlideWidth(),
                                                    flexShrink: 0,
                                                    padding: '0 10px',
                                                    boxSizing: 'border-box'
                                                }}
                                            >
                                                <div
                                                    className="tour-package-box"
                                                    style={{
                                                        background: 'white',
                                                        borderRadius: '15px',
                                                        overflow: 'hidden',
                                                        boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
                                                        transition: 'all 0.3s ease',
                                                        height: '100%',
                                                        maxWidth: '380px',
                                                        margin: '0 auto'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.transform = 'translateY(-8px)';
                                                        e.currentTarget.style.boxShadow = '0 15px 30px rgba(0, 0, 0, 0.12)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                        e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.08)';
                                                    }}
                                                >
                                                    <div
                                                        className="tour-package-thumb"
                                                        style={{
                                                            position: 'relative',
                                                            overflow: 'hidden',
                                                            height: '220px'
                                                        }}
                                                    >
                                                        <img
                                                            src={pkg.image}
                                                            alt={pkg.title}
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'cover',
                                                                transition: 'transform 0.3s ease'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.target.style.transform = 'scale(1.05)';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.target.style.transform = 'scale(1)';
                                                            }}
                                                        />
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: '12px',
                                                                right: '12px',
                                                                background: '#f7921f',
                                                                color: 'white',
                                                                padding: '4px 10px',
                                                                borderRadius: '15px',
                                                                fontSize: '11px',
                                                                fontWeight: '600'
                                                            }}
                                                        >
                                                            {pkg.discount}
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="tour-package-content"
                                                        style={{
                                                            padding: '20px'
                                                        }}
                                                    >
                                                        <h5
                                                            className="title"
                                                            style={{
                                                                fontSize: '16px',
                                                                fontWeight: '700',
                                                                marginBottom: '12px',
                                                                lineHeight: '1.4',
                                                                color: '#2c3e50',
                                                                minHeight: '45px',
                                                                display: '-webkit-box',
                                                                WebkitLineClamp: 2,
                                                                WebkitBoxOrient: 'vertical',
                                                                overflow: 'hidden'
                                                            }}
                                                        >
                                                            <Link
                                                                to={`/book/${pkg.packageId}`}
                                                                style={{
                                                                    color: 'inherit',
                                                                    textDecoration: 'none',
                                                                    transition: 'color 0.3s ease'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.color = '#f7921f';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.color = '#2c3e50';
                                                                }}
                                                            >
                                                                {pkg.title}
                                                            </Link>
                                                        </h5>
                                                        <div
                                                            className="pricing-container"
                                                            style={{
                                                                marginBottom: '15px'
                                                            }}
                                                        >
                                                            <div
                                                                className="package-info"
                                                                style={{
                                                                    marginBottom: '12px'
                                                                }}
                                                            >
                                                                <span
                                                                    className="package-location"
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        color: '#666',
                                                                        fontSize: '13px',
                                                                        marginBottom: '6px'
                                                                    }}
                                                                >
                                                                    <i
                                                                        className="fas fa-map-marker-alt"
                                                                        style={{ marginRight: '6px', color: '#f7921f', width: '14px', fontSize: '12px' }}
                                                                    ></i>
                                                                    {pkg.location}
                                                                </span>
                                                                <span
                                                                    className="package-time"
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        color: '#666',
                                                                        fontSize: '13px'
                                                                    }}
                                                                >
                                                                    <i
                                                                        className="fas fa-clock"
                                                                        style={{ marginRight: '6px', color: '#f7921f', width: '14px', fontSize: '12px' }}
                                                                    ></i>
                                                                    {pkg.duration}
                                                                </span>
                                                            </div>
                                                            <div
                                                                className="price-info"
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center'
                                                                }}
                                                            >
                                                                <div className="price">
                                                                    <h6
                                                                        style={{
                                                                            fontSize: '20px',
                                                                            fontWeight: '700',
                                                                            color: '#2c3e50',
                                                                            margin: '0 0 3px 0'
                                                                        }}
                                                                    >
                                                                        ₹{pkg.price}
                                                                    </h6>
                                                                    <del
                                                                        style={{
                                                                            fontSize: '13px',
                                                                            color: '#999'
                                                                        }}
                                                                    >
                                                                        ₹{pkg.originalPrice}
                                                                    </del>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <Link
                                                            to={`/book/${pkg.packageId}`}
                                                            style={{
                                                                display: 'block',
                                                                background: '#f7921f',
                                                                color: 'white',
                                                                padding: '10px 16px',
                                                                borderRadius: '25px',
                                                                textAlign: 'center',
                                                                textDecoration: 'none',
                                                                fontWeight: '600',
                                                                textTransform: 'uppercase',
                                                                letterSpacing: '0.5px',
                                                                transition: 'all 0.3s ease',
                                                                border: '2px solid #f7921f',
                                                                fontSize: '13px'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.target.style.background = 'transparent';
                                                                e.target.style.color = '#f7921f';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.target.style.background = '#f7921f';
                                                                e.target.style.color = 'white';
                                                            }}
                                                        >
                                                            Book Now
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add CSS for responsive behavior */}
            <style jsx>{`
                .tour-package-slider-container {
                    width: 100%;
                    overflow: hidden;
                    position: relative;
                }
                .tour-package-slider {
                    display: flex;
                    transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
                }
                .tour-package-slide-group {
                    flex-shrink: 0;
                    display: flex;
                    padding: 0 15px;
                    box-sizing: border-box;
                }
                .tour-package-slide {
                    flex-shrink: 0;
                    padding: 0 10px;
                    box-sizing: border-box;
                }
                
                @media (max-width: 768px) {
                    .tour-package-slide {
                        width: 100% !important;
                    }
                    .tour-package-box {
                        max-width: 100% !important;
                    }
                }
                @media (min-width: 769px) and (max-width: 991px) {
                    .tour-package-slide {
                        width: 50% !important;
                    }
                    .tour-package-box {
                        max-width: 340px !important;
                    }
                }
                @media (min-width: 992px) {
                    .tour-package-slide {
                        width: 33.333% !important;
                    }
                    .tour-package-box {
                        max-width: 380px !important;
                    }
                }
            `}</style>
        </section>
    );
};

export default TourPackages;